import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog"

import useDeleteApiReq from "@/hooks/useDeleteApiReq";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const DeletePartnerModal = ({ setIsDeleteModalOpen, isDeleteModalOpen, getPartnerDetail,status }) => {
    const { res, fetchData, isLoading } = useDeleteApiReq();

    const [option, setOption] = useState("block");
    const params = useParams();
    const navigate = useNavigate();

    const handleDelete = async (option) => {
        setOption(option);
        fetchData(`/admin/partner/${params?.partnerId}?option=${option}`);
    }

    console.log("delete partner res", res);
    useEffect(() => {
        if (res?.status === 200 || res?.status === 201) {
            toast.success(res?.data?.message);
            setIsDeleteModalOpen(false);
            if (option === "block") {
                getPartnerDetail();
            }
            else {
                navigate(-1)
            }
        }
    }, [res]);

    return (
        <Dialog open={isDeleteModalOpen} onOpenChange={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Partner</DialogTitle>
                    <DialogDescription>
                        This will  permanently delete the partner.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex gap-2 items-center mt-4 justify-end">
                {status && <Button variant="destructive" onClick={() => handleDelete("block")}>Block</Button>}
                    <Button onClick={() => handleDelete("delete")}>Delete</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default DeletePartnerModal